import { render, staticRenderFns } from "./AddOrEditDiscountPackage.vue?vue&type=template&id=58f95796"
import script from "./AddOrEditDiscountPackage.vue?vue&type=script&lang=js"
export * from "./AddOrEditDiscountPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports